import textLogo from '../assets/code-box-text-logo.svg';
import markLogo from '../assets/code-box-logo.png';

/**
 * The two official Code Box marks.
 *
 * - `CodeBoxMark` — the chevron mark (yellow `<` / blue `>`), legible on any background. Use it in
 *   headers and other compact chrome.
 * - `CodeBoxWordmark` — the full "CODE BOX" lockup. Its lettering is WHITE with a drop shadow, so
 *   it only works on the deep brand blue — always pair it with a `bg-brand` panel (sign-in hero),
 *   never on plain surface.
 */
export function CodeBoxMark({ className }: { className?: string }) {
  return <img src={markLogo} alt="Code Box" className={className ?? 'h-7 w-auto'} draggable={false} />;
}

export function CodeBoxWordmark({ className }: { className?: string }) {
  return <img src={textLogo} alt="Code Box" className={className ?? 'h-24 w-auto'} draggable={false} />;
}
